module.exports = {"operation":{"classRoute":"operation","permission":{"name":"operation.dashboard","actions":["visit"]},"link":"/operation/tour/tourSales","text":"menu.operation.text","icon":"fal fa-route","sub":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/app/user/partials/navbar/mainMenu.json
// module id = hsFI
// module chunks = 8